import React from 'react'

export default class Services extends React.Component {
  render() {
    return (
      <div className="section translucent-bg bg-image-1 blue" id="services">
        <div className="container-fluid " data-animation-effect="fadeIn">
          <h1 className="text-center title" style={{ marginTop: '4.5%' }}>
            NicheSolv Services
          </h1>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="media">
                <div className="media-left" />
                <div className="media-body">
                  <h3 className="media-heading">Software Development</h3>
                  <p>
                    We can help you build your software from the ground up, or
                    help augment your development team. We have experience
                    building solutions in diverse domains like Networking,
                    Blockchain Gaming, Industrial Engineering, B2C & B2B
                    Portals, Airlines & Logistics, Travel & Leisure. Though we
                    have extensive experience on server-side Java/J2EE, we are
                    executing projects on C# Dot Net/Perl also.
                  </p>
                </div>
              </div>
              <div className="media">
                <div className="media-left" />
                <div className="media-body">
                  <h3 className="media-heading">DevOps Services</h3>
                  <p>
                    Today's need of the hour is to improve business value
                    through continuous delivery of products that satisfy
                    customer needs. Our devops team compile, test and publish
                    software quickly and reliably.
                  </p>
                </div>
              </div>
              <div className="media">
                <div className="media-left" />
                <div className="media-body">
                  <h3 className="media-heading">Data Science</h3>
                  <p>
                    Data Science team focuses on problem-solving and building
                    data driven solutions to address the pain point &amp;
                    bottlenecks in industry and society. Our AI / ML workflow
                    involves Data Management / Processing, Model Development and
                    Tuning, Validation and Deployment of Production Ready Models
                    and Model Update. Our capabilities include Computer Vision,
                    NLP and Modeling Time Series Data. We leverage pre-trained
                    models and packages / frameworks / libraries such as
                    Tensorflow, Keras, SKlearn, OpenCV, Numpy, Pandas, NLTK
                    &amp; SpaCy.
                  </p>
                </div>
              </div>
              <div className="media">
                <div className="media-left" />
                <div className="media-body row col-lg-12 col-md-12 col-sm-12 col-xs-12 erpContainer">
                  <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                    {' '}
                    <h3 className="media-heading">ERP Integration Service</h3>
                    <p>
                      NicheSolv is an official partner of Odoo. We manage the
                      complete implementation of Odoo ERP solution for customers
                      that includes :{' '}
                    </p>
                    <ul>
                      <li>
                        Evaluation of business requirements and recommend
                        suitable Apps
                      </li>
                      <li>
                        Odoo client registration, procurement of Apps and
                        configuration of backend Database on the Cloud platform
                      </li>
                      <li>
                        Conduct detailed business analysis and create gap
                        document
                      </li>
                      <li>
                        Module configuration and development of customization as
                        required
                      </li>
                      <li>Conduct User-Testing and Training workshops</li>
                      <li>
                        Manage Go-live activities that include Data Migration,
                        reconciliation and post-Go-live support
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    {' '}
                    <img src="images/Odoo/odoo.png" alt="odooImage" />{' '}
                  </div>
                </div>
              </div>

              <div className="media">
                <div className="media-left" />
                <div className="media-body">
                  <h3 className="media-heading">Testing Services</h3>
                  <p />
                  <ul>
                    <li>Test Automation</li>
                    <li>Performance Testing</li>
                    <li>White Box/Black Box/Manual Testing</li>
                  </ul>
                  Automated software testing is becoming more and more important
                  for many software projects in order to automatically verify
                  functionality, regress and help teams run a large number of
                  tests in short cycle time. <br /> Our team can help you with
                  some of the most popular open source tools like Selenium,
                  SoapUI, JUnit, TestNG, Jmeter and our in house tools and
                  frameworks.
                  <p />
                </div>
              </div>

              <div className="media">
                <div className="media-left" />
                <div className="media-body">
                  <h3 className="media-heading">Cloud Application Services</h3>
                  <p>
                    We also provide services to help you migrate to the cloud.
                  </p>
                  <ul>
                    <li>
                      Understanding your requirements, and helping you choose
                      the right applications
                    </li>
                    <li>
                      Helping you migrate your existing applications to the
                      cloud
                    </li>
                    <li>
                      Help you develop applications that are to be run on the
                      cloud
                    </li>
                  </ul>
                </div>
              </div>
              <div className="media">
                <div className="media-left" />
                <div className="media-body">
                  <h3 className="media-heading">vCTO</h3>
                  <p>
                    We take on a CTO role for our customers. Our activities
                    include
                  </p>
                  <ul>
                    <li>
                      Review the architecture & design of web, mobile and cloud
                      applications
                    </li>
                    <li>
                      Selection of technologies and resources that are needed
                      for delivery
                    </li>
                    <li>
                      Help the CXO team prepare a product roadmap aligned with
                      their business strategy
                    </li>
                    <li>
                      Mentor engineering teams to inculcate a software
                      engineering discipline, and mature to the next level of
                      execution
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/services.js